import { useState } from 'react';
import { ButtonBase, makeStyles, Box, ClickAwayListener, Tooltip, Zoom } from '@material-ui/core';
import { ElderlyHomeIcon } from '../Icon';
import { classNames } from '../../utils';

const useStyles = makeStyles(() => ({
  trigger: {
    display: 'inline-flex',
    padding: 0,
    borderRadius: 0,
    cursor: 'pointer',
  },
  dialog: {
    '& .MuiDialog-paper': {
      width: '19.75rem',
      maxWidth: 'calc(100vw - 2rem)',
      margin: '1rem',
      borderRadius: '0.625rem',
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
      overflow: 'hidden',
    },
  },
  content: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.571rem',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem',
  },
  name: {
    color: '#231F20',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.125rem',
    fontWeight: 500,
    lineHeight: '1.5rem',
  },
  code: {
    flexShrink: 0,
    border: '1.5px solid #93A9FF',
    borderRadius: '0.5rem',
    backgroundColor: '#D2DBFF',
    color: '#607ADD',
    fontFamily: 'NotoSans-Bold',
    fontSize: '0.875rem',
    fontWeight: 700,
    textAlign: 'center',
    padding: '0.5rem',
  },
  englishName: {
    color: '#3E3E3E',
    fontFamily: 'NotoSans-Regular',
    fontSize: '1rem',
    lineHeight: '1.25rem',
  },
  elderlyHomeIcon: {
    width: '1.714rem',
    height: '1.714rem',
  },
  arrow: {
    color: '#FFFFFF',
    '&::before': {
      boxShadow: '0 0 0.5rem 0 rgba(125, 134, 169, 0.2)',
    },
  },
  tooltip: {
    borderRadius: '0.625rem',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
    backgroundColor: '#FFFFFF',
    padding: '1.142rem',
    color: '#333',
    width: '26rem',
    maxWidth: 'calc(100vw - 2rem)',
    boxSizing: 'border-box',
  },
}));

const ElderlyHomeContent = ({ ehAddrInfo }) => {
  const classes = useStyles();

  return (
    <div className={classes.content}>
      <div className={classes.header}>
        <div className={classes.name}>{ehAddrInfo.ehChineseName}</div>
        <div className={classes.code}>{ehAddrInfo.ehCode}</div>
      </div>
      <div className={classes.englishName}>{ehAddrInfo.ehName}</div>
    </div>
  );
};

const ElderlyHomeInfo = ({ containerClass, iconClass, onClick, ehAddrInfo = null, emptyIcon = null }) => {
  const classes = useStyles();
  const [toolTipOpen, setToolTipOpen] = useState(false);

  const handleOpen = (event) => {
    event.stopPropagation();
    if (onClick) {
      onClick(event);
    }
    setToolTipOpen(true);
  };

  const handleTooltipClose = (event) => {
    event.stopPropagation();
    setToolTipOpen(false);
  };

  if (!ehAddrInfo) {
    if (emptyIcon) {
      return emptyIcon;
    }
    return null;
  }

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <Box className={containerClass}>
        <Tooltip
          id="elderly-home-tooltip"
          classes={classes}
          title={<ElderlyHomeContent ehAddrInfo={ehAddrInfo} />}
          arrow
          TransitionComponent={Zoom}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          onClose={handleTooltipClose}
          open={toolTipOpen}
        >
          <ButtonBase
            className={classes.trigger}
            onClick={handleOpen}
            onKeyUp={(event) => event.stopPropagation()}
            aria-label="Elderly Home"
          >
            <ElderlyHomeIcon className={classNames(classes.elderlyHomeIcon, iconClass)} />
          </ButtonBase>
        </Tooltip>
      </Box>
    </ClickAwayListener>
  );
};

export default ElderlyHomeInfo;
